<template>
    <!--Modal-->
    <div class="modal fade" id="editReviewModal" tabindex="-1" role="dialog" aria-labelledby="reviewModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="alertdialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ reviewInfo.IsConfirmed ? 'مشاهده' : 'مشاهده و ویرایش' }} نظر</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="content-review col-md-12 col-xs-12">
                            <div class="row">
                                <div class="commentmetadata col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                    <h2 class="title">نام محصول</h2>
                                    <span class="date">
                                        {{reviewInfo.ProductName}}
                                    </span>
                                </div>
                                <div class="commentmetadata col-lg-6 col-sm-6 col-md-6  col-xs-12">
                                    <h2 class="title">تاریخ و زمان ثبت نظر</h2>
                                    <span class="date">
                                        {{reviewInfo.RegDateTime}}
                                    </span>
                                </div>
                                <div class="commentmetadata col-lg-6 col-sm-6 col-md-6 col-xs-12">
                                    <h2 class="title">تاریخ و زمان تأیید نظر</h2>
                                    <span class="date">
                                        {{reviewInfo.ConfirmedDateTime}}
                                    </span>
                                </div>

                            </div>
                            <hr />
                            <form @submit.prevent="updatReview">
                                <div class="col-sm-12 col-md-12 pull-right">
                                    <div class="form-account-title">عنوان نظر شما (اجباری)</div>
                                    <div class="form-account-row">
                                        <input v-model="reviewInfo.Title" name="Title" v-validate="{ required: true}" data-vv-as="عنوان نظر شما" class="input-field" placeholder="عنوان نظر خود را بنویسید">
                                        <span class="error">{{ errors.first('Title') }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 pull-right">
                                    <div class="form-account-title">متن نظر شما (اجباری)</div>
                                    <div class="form-account-row">
                                        <textarea v-model="reviewInfo.Text" name="Text" rows="2" v-validate="{ required: true,min:10}" data-vv-as="متن نظر شما" class="input-field" style="min-height:250px;resize:none;" placeholder="متن نظر خود را بنویسید"></textarea>
                                        <span class="error">{{ errors.first('Text') }}</span>
                                    </div>
                                </div>
                                <div class="btn-main pull-left">
                                    <input type="button" class="btn btn-danger btn-sm" value="بستن" data-dismiss="modal" />
                                    <input v-if="!reviewInfo.IsConfirmed" type="submit" value="ثبت" class="btn btn-info btn-sm">
                                </div>
                            </form>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!--Modal-->
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    import { reviewChangedEventBus } from "../../../eventBus/eventBus";
    export default {
        props: {
            reviewInfo: {
                type: Object,
                required: true,
            }
        },
        methods: {
            updatReview() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowLoader = true;
                        httpPromise(this, '/v1/ProductManagement/CustomerReviews/Update', 'put', JSON.stringify(this.reviewInfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                reviewChangedEventBus.$emit('updateReviewEvent', '');
                                this.isShowLoader = false;
                                $(function () {
                                    $('#editReviewModal').modal('hide');
                                });
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            },
            closeModal() {
                $(function () {
                    $('#editReviewModal').modal('hide');
                });
            }
        }
    }

</script>

<style scoped>
    .commentmetadata {
        margin-bottom: 20px;
    }

        .commentmetadata .title {
            font-size: 14px;
            text-align: right;
            margin-bottom: 10px;
            margin-top: 10px;
        }

        .commentmetadata .date {
            color: #888;
            font-size: 13px;
        }

    .form-account-title {
        font-size: 14px;
    }

    .modal-content .modal-header {
        border-bottom: none;
        padding-top: 8px;
        padding-right: 24px;
        padding-bottom: 13px;
        padding-left: 24px;
    }

    .modal-content .modal-header {
        background-color: #aec7f4;
    }

    .modal h5 {
        font-size: 18px;
        font-weight: bold;
        color: #fff;
    }

    .modal .modal-header .close {
        color: #fff;
    }

    .modal-content .modal-header button {
        left: 13px;
        right: unset;
        top: 6px;
    }

    .close {
        font-size: 31px !important;
    }

    .modal-content {
        border-radius: 0;
    }

    .modal-header {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .input-field {
        padding: 8px 8px 8px 8px;
    }

        .input-field::placeholder {
            font-size: 13px;
        }

    .btn-info {
        padding: 3px 15px !important;
        font-weight: unset !important;
        margin-left: 10px;
    }

    .center {
        padding: 20px;
    }
</style>